import { render, staticRenderFns } from "./BillRow.vue?vue&type=template&id=1840b084&scoped=true"
import script from "./BillRow.vue?vue&type=script&lang=js"
export * from "./BillRow.vue?vue&type=script&lang=js"
import style0 from "./BillRow.vue?vue&type=style&index=0&id=1840b084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840b084",
  null
  
)

export default component.exports